import { HierarchyActions } from './HierarchyActions';
import { ActionTypes } from './ActionTypes';
import { downloader } from '../layout/Download';

export { ActionTypes }

export class Actions extends HierarchyActions {

    updateUser(user: ICurrentUser) {
        this.dispatch({
            type: ActionTypes.UpdateUser,
            data: user
        });
    }

    download(url: string) {
        downloader(url);
    }

    getLocation(itemId: string): string {
        const state: IAppStoreState = AppStore.getState();
        let item = state.hierarchyMap[itemId];

        if (!item) {
            return null;
        }

        let locations = [];

        while (item && item.id) {
            locations.push(item.name);
            item = item.parent;
        }

        locations = locations.reverse();

        return locations.join(' / ');
    }

    hierarchyUpdated() {
        this.dispatch({
            type: ActionTypes.HierarchyUpdated
        });
    }

    applyFilter(filter: Hierarchy.Filter, result: Hierarchy.FilterResult) {
        this.dispatch({
            type: ActionTypes.HierarchyFilter,
            data: {
                filter,
                result
            }
        });
    }

    filterClear() {
        this.dispatch({
            type: ActionTypes.HierarchyFilterClear,
        });
    }
}

export default new Actions();
